// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"MainContentMeuHotelDistanciasAcomodacao_sectionTitle__1xsIA","placeholderShimmer":"MainContentMeuHotelDistanciasAcomodacao_placeholderShimmer__3l2LD"};